import { useState, useEffect } from 'react';

const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

interface BreakpointState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  width: number;
}

export function useBreakpoint(): BreakpointState {
  const [state, setState] = useState<BreakpointState>(() => {
    const w = typeof window !== 'undefined' ? window.innerWidth : 1024;
    return {
      isMobile: w < BREAKPOINTS.md,
      isTablet: w >= BREAKPOINTS.md && w < BREAKPOINTS.lg,
      isDesktop: w >= BREAKPOINTS.lg,
      width: w,
    };
  });

  useEffect(() => {
    const mqlMobile = window.matchMedia(`(max-width: ${BREAKPOINTS.md - 1}px)`);
    const mqlDesktop = window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`);

    function update() {
      const w = window.innerWidth;
      setState({
        isMobile: w < BREAKPOINTS.md,
        isTablet: w >= BREAKPOINTS.md && w < BREAKPOINTS.lg,
        isDesktop: w >= BREAKPOINTS.lg,
        width: w,
      });
    }

    mqlMobile.addEventListener('change', update);
    mqlDesktop.addEventListener('change', update);
    return () => {
      mqlMobile.removeEventListener('change', update);
      mqlDesktop.removeEventListener('change', update);
    };
  }, []);

  return state;
}
